'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _defaultProps = require('../default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PerspectiveY = function (_React$Component) {
	(0, _inherits3.default)(PerspectiveY, _React$Component);

	function PerspectiveY() {
		(0, _classCallCheck3.default)(this, PerspectiveY);
		return (0, _possibleConstructorReturn3.default)(this, (PerspectiveY.__proto__ || Object.getPrototypeOf(PerspectiveY)).apply(this, arguments));
	}

	(0, _createClass3.default)(PerspectiveY, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    width = _props.width,
			    lineHeight = _props.lineHeight,
			    lineSpacing = _props.lineSpacing;

			var offset = lineHeight + lineSpacing;
			return _react2.default.createElement(
				_base2.default,
				(0, _extends3.default)({ typeClassName: 'BurgerPerspectiveY' }, this.props),
				_react2.default.createElement(_style2.default, {
					styleId: '2620467554',
					css: '.BurgerPerspectiveY .BurgerBox{-webkit-perspective:' + width * 2 + 'px;-moz-perspective:' + width * 2 + 'px;-ms-perspective:' + width * 2 + 'px;perspective:' + width * 2 + 'px;}.BurgerPerspectiveY .BurgerInner{-webkit-transition:-webkit-transform 0.15s cubic-bezier(0.645,0.045,0.355,1), background-color 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);-webkit-transition:transform 0.15s cubic-bezier(0.645,0.045,0.355,1), background-color 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);transition:transform 0.15s cubic-bezier(0.645,0.045,0.355,1), background-color 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);}.BurgerPerspectiveY .BurgerInner:before,.BurgerPerspectiveY .BurgerInner:after{-webkit-transition:-webkit-transform 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);-webkit-transition:transform 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);transition:transform 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);}.BurgerPerspectiveY.BurgerActive .BurgerInner{background-color:transparent;-webkit-transform:rotateX(-180deg);-ms-transform:rotateX(-180deg);transform:rotateX(-180deg);}.BurgerPerspectiveY.BurgerActive .BurgerInner:before{-webkit-transform:translate3d(0,' + offset + 'px,0) rotate(45deg);-ms-transform:translate3d(0,' + offset + 'px,0) rotate(45deg);transform:translate3d(0,' + offset + 'px,0) rotate(45deg);}.BurgerPerspectiveY.BurgerActive .BurgerInner:after{-webkit-transform:translate3d(0,' + offset * -1 + 'px,0) rotate(-45deg);-ms-transform:translate3d(0,' + offset * -1 + 'px,0) rotate(-45deg);transform:translate3d(0,' + offset * -1 + 'px,0) rotate(-45deg);}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=../../src/types/perspective-y.js */',
					dynamic: [width * 2, offset, offset * -1]
				})
			);
		}
	}]);
	return PerspectiveY;
}(_react2.default.Component);

exports.default = PerspectiveY;


PerspectiveY.defaultProps = _defaultProps2.default;
module.exports = exports['default'];
//# sourceMappingURL=perspective-y.js.map